export const DotDivider = (props: { className?: string }) => {
  return <span className={props.className}>&#183;</span>;
};

export const LargeDotDivider = ({ className }: { className?: string }) => {
  return <span className={`text-medium-hippo ${className}`}>{"\u2022"}</span>;
};
export const VerticalDivider = (props: { className?: string }) => {
  return <span className={props.className}>&#124;</span>;
};
